import { selectCountries } from "../../../../components/appData.slice";
import { FormElement, FormId } from "../../../../components/enums";
import {
  FormSchema,
  SimpleFormSchemaComponents,
} from "../../../../components/types";
import { provinces } from "../../../../shared";
import {
  selectCountry,
  selectIsDefaultCountrySelected,
  selectIsNotDefaultCountrySelected,
} from "../../../../store/HOC/genericUI.selectors";
import { peselMask, postalCodeMask } from "../../../../utilities/masks";
import {
  selectPerpetratorData,
  shouldDisplayPerpetratorPerson,
  shouldDisplayPerpetratorAddress,
  shouldDisplayPerpetratorAddressWhenDriving,
  selectUIData,
  selectPerpetratorAvailableCities,
} from "../perpetrator.selectors";
import {
  setAvailableCities,
  setUIField,
  setUIObjectField,
} from "../perpetrator.slice";

import { ComponentId } from "./enums";

export const main: FormSchema<SimpleFormSchemaComponents> = {
  formId: FormId.PERPETRATOR_DATA,
  selector: selectPerpetratorData,
  isVisible: shouldDisplayPerpetratorPerson,
  content: [
    {
      title: "Dane sprawcy",
      sections: [
        {
          id: "perpetrator-data-1",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.INPUT,
              id: ComponentId.PERPETRATOR_NAME,
              label: "Imię",
            },
            {
              type: FormElement.INPUT,
              id: ComponentId.PERPETRATOR_SURNAME,
              label: "Nazwisko",
            },
          ],
        },
        {
          id: "perpetrator-data-2",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.PHONE,
              country: selectCountry(selectUIData)("perpetratorphone"),
              onChange: setUIObjectField,
              id: ComponentId.PERPETRATOR_PHONE,
              label: "Telefon",
            },
            {
              type: FormElement.INPUT,
              id: ComponentId.PERPETRATOR_EMAIL,
              label: "Email",
            },
          ],
        },
        {
          id: "perpetrator-data-3",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.INPUT,
              mask: peselMask,
              id: ComponentId.PERPETRATOR_PESEL,
              label: "PESEL",
            },
          ],
        },
      ],
    },
  ],
};

export const address: FormSchema<SimpleFormSchemaComponents> = {
  formId: FormId.PERPETRATOR_DATA,
  id: [FormId.PERPETRATOR_DATA, "address"].join("-"),
  selector: selectPerpetratorData,
  isVisible: shouldDisplayPerpetratorAddress,
  content: [
    {
      sections: [
        {
          title: "Miejsce zamieszkania",
          id: "perpetrator-data-8",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.INPUT,
              id: ComponentId.PERPETRATOR_STREET,
              label: "Ulica",
            },
            {
              type: FormElement.INPUT,
              id: ComponentId.PERPETRATOR_STREET_2,
              label: "Numer budynku / mieszkania",
            },
          ],
        },
        {
          id: "perpetrator-data-9",
          wrapper: { xs: 12 },
          components: [
            {
              isVisible: selectIsNotDefaultCountrySelected(selectUIData)(
                "companyData[country]"
              ),
              type: FormElement.ZIP_CODE,
              mask: postalCodeMask,
              id: ComponentId.PERPETRATOR_ZIP_CODE_PL,
              label: "Kod pocztowy",
              // LPPLWEBMOB-728
              onChange: setAvailableCities,
            },
            {
              isVisible: selectIsDefaultCountrySelected(selectUIData)(
                "companyData[country]"
              ),
              type: FormElement.INPUT,
              id: ComponentId.PERPETRATOR_ZIP_CODE_GENERIC,
              label: "Kod pocztowy",
            },
            // LPPLWEBMOB-728
            {
              isVisible: selectIsNotDefaultCountrySelected(selectUIData)(
                "circumstances[country]"
              ),
              type: FormElement.SELECT_CITY,
              id: ComponentId.PERPETRATOR_CITY,
              label: "Miejscowość",
              items: [],
              selectAvailableCities: selectPerpetratorAvailableCities,
            },
            {
              isVisible: selectIsDefaultCountrySelected(selectUIData)(
                "circumstances[country]"
              ),
              type: FormElement.INPUT,
              id: ComponentId.PERPETRATOR_CITY,
              label: "Miejscowość",
            },
          ],
        },
        {
          id: "perpetrator-data-10",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.AUTOCOMPLETE,
              id: ComponentId.PERPETRATOR_COUNTRY,
              onChange: setUIField,
              items: selectCountries,
              label: "Kraj",
            },
            {
              type: FormElement.SELECT,
              id: ComponentId.PERPETRATOR_PROVINCE,
              disabled: selectIsDefaultCountrySelected(selectUIData)(
                "perpetrator[country]"
              ),
              label: "Województwo",
              items: [...provinces],
            },
          ],
        },
      ],
    },
  ],
};

export const addressWhileDriving: FormSchema<SimpleFormSchemaComponents> = {
  formId: FormId.PERPETRATOR_DATA,
  id: [FormId.PERPETRATOR_DATA, "addressWhileDriving"].join("-"),
  selector: selectPerpetratorData,
  isVisible: shouldDisplayPerpetratorAddressWhenDriving,
  content: [
    {
      sections: [
        {
          title: "Miejsce zamieszkania",
          id: "perpetrator-data-11",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.INPUT,
              id: ComponentId.PERPETRATOR_STREET,
              label: "Ulica",
            },
            {
              type: FormElement.INPUT,
              id: ComponentId.PERPETRATOR_STREET_2,
              label: "Numer budynku / mieszkania",
            },
          ],
        },
        {
          id: "perpetrator-data-12",
          wrapper: { xs: 12 },
          components: [
            {
              isVisible: selectIsNotDefaultCountrySelected(selectUIData)(
                "companyData[country]"
              ),
              type: FormElement.ZIP_CODE,
              mask: postalCodeMask,
              id: ComponentId.PERPETRATOR_ZIP_CODE_PL,
              label: "Kod pocztowy",
              // LPPLWEBMOB-728
              onChange: setAvailableCities,
            },
            {
              isVisible: selectIsDefaultCountrySelected(selectUIData)(
                "companyData[country]"
              ),
              type: FormElement.INPUT,
              id: ComponentId.PERPETRATOR_ZIP_CODE_GENERIC,
              label: "Kod pocztowy",
            },
            // LPPLWEBMOB-728
            {
              isVisible: selectIsNotDefaultCountrySelected(selectUIData)(
                "circumstances[country]"
              ),
              type: FormElement.SELECT_CITY,
              id: ComponentId.PERPETRATOR_CITY,
              label: "Miejscowość",
              items: [],
              selectAvailableCities: selectPerpetratorAvailableCities,
            },
            {
              isVisible: selectIsDefaultCountrySelected(selectUIData)(
                "circumstances[country]"
              ),
              type: FormElement.INPUT,
              id: ComponentId.PERPETRATOR_CITY,
              label: "Miejscowość",
            },
          ],
        },
        {
          id: "perpetrator-data-13",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.AUTOCOMPLETE,
              id: ComponentId.PERPETRATOR_COUNTRY,
              onChange: setUIField,
              items: selectCountries,
              label: "Kraj",
            },
            {
              type: FormElement.SELECT,
              id: ComponentId.PERPETRATOR_PROVINCE,
              disabled: selectIsDefaultCountrySelected(selectUIData)(
                "perpetrator[country]"
              ),
              label: "Województwo",
              items: [...provinces],
            },
          ],
        },
      ],
    },
  ],
};
export const insurance: FormSchema<SimpleFormSchemaComponents> = {
  formId: FormId.PERPETRATOR_DATA,
  id: [FormId.PERPETRATOR_DATA, "insurance", "person"].join("-"),
  selector: selectPerpetratorData,
  isVisible: shouldDisplayPerpetratorAddress,
  content: [
    {
      sections: [
        {
          title: "Dane polisy",
          id: "perpetrator-car-insurance",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.INPUT,
              id: ComponentId.PERPETRATOR_OC_NUMBER,
              label: "Numer polisy OC",
            },
            {
              type: FormElement.INPUT,
              id: ComponentId.PERPETRATOR_INSURANCE_COMPANY,
              label: "Towarzystwo ubezpieczeniowe",
            },
          ],
        },
      ],
    },
  ],
};
